<template>
    <v-container class="wrapper-ticket-list pa-0">
        <v-container class="d-flex justify-space-between align-center pa-0">
            <v-card-text class="text-h3 pa-0">تیکت ها</v-card-text>
            <v-btn
                custom
                depressed
                color="primary"
                @click="createNewTicket"
            >
                <span>تیکت جدید</span>
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </v-container>
        <v-container class="pa-0 mt-4">
            <autocomplete
                v-model="department"
                :title="$t('departments')"
                type="departments"
                :value="department"
                @clear="fetchDataWithoutDepartment"
            />
        </v-container>
        <v-container class="d-flex gap-2 pa-0 mt-8">
            <v-text-field
                class="flex-fill"
                :label="$t('search')"
                append-icon="mdi-magnify"
                v-model="search"
                clear-icon="mdi-close"
                outlined
                dense
                clearable
                @click:clear="fetchDataWithoutSearch"
            />
            <v-btn
            outlined
            custom
            style="height: 34px !important;"
            @click="$emit('isFilterDrawerVisible')"
            >
                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.64282 7.8795C3.77757 6.4845 2.44707 4.95 1.72032 4.0875C1.49532 3.8205 1.42182 3.62475 1.37757 3.2805C1.22607 2.1015 1.15032 1.512 1.49607 1.131C1.84182 0.75 2.45307 0.75 3.67557 0.75H12.3246C13.5471 0.75 14.1583 0.75 14.5041 1.13025C14.8498 1.51125 14.7741 2.10075 14.6226 3.27975C14.5776 3.624 14.5041 3.81975 14.2798 4.08675C13.5523 4.95075 12.2196 6.48825 10.3498 7.8855C10.2634 7.95278 10.1919 8.03735 10.14 8.13382C10.0881 8.23029 10.0568 8.33653 10.0483 8.44575C9.86307 10.494 9.69207 11.616 9.58557 12.183C9.41382 13.0995 8.11557 13.6508 7.41957 14.142C7.00557 14.4345 6.50307 14.0865 6.44982 13.6335C6.25067 11.9074 6.08214 10.1779 5.94432 8.44575C5.93661 8.33549 5.90579 8.22809 5.85384 8.13053C5.80189 8.03297 5.73 7.94744 5.64282 7.8795Z" stroke="#030303" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </v-btn>
        </v-container>

        <v-container
            ref="scrollSection"
            v-if="tickets != null && tickets.length > 0"
            :style="{ 'overflow-y': totalPage > currentPage ? 'scroll' : 'auto'}"
            class="list pa-0 mt-5"
        >
            <v-card
                v-for="(item, index) in tickets"
                :key="index"
                @click="selectTicket(item, index)"
                :class="{ 'active': isTicketSelected && selectedTicket == index }"
            >
                <div class="d-flex justify-space-between align-center">
                    <div>
                        <v-card-text class="text-body-1 pa-0">{{ item.title ? item.title.length > 25 ? item.title.substring(0, 25) + '...' : item.title : '' }}</v-card-text>
                    </div>
                    <div>
                        <v-card-text
                            :style="{ 'color': '#' + item.status.color }"
                            class="text-body-2 pa-0"
                        >
                            {{ $t(item.status.name) }}
                        </v-card-text>
                    </div>
                </div>
                <div class="d-flex justify-space-between align-center mt-3">
                    <div>
                        <v-card-text class="text-body-2 pa-0">{{ item.user ? item.user.firstname : '-' }} {{ item.user ? item.user.lastname : '-' }}</v-card-text>
                    </div>
                    <div>
                        <v-card-text class="text-body-1 pa-0">{{ item.time }}</v-card-text>
                    </div>
                </div>
            </v-card>
        </v-container>

        <v-container
            v-else
            class="wrapper-empty-ticket text-center pa-0"
        >
            <img src="@/assets/ticket/layer-3.png" />
            <v-card-text class="text-h3 pa-0 my-3">{{ $t("there is no message yet") }}</v-card-text>
            <v-card-text class="text-h4 pa-0" style="color: #7c7979;">{{ $t("write your message") }}</v-card-text>
        </v-container>

    </v-container>
</template>

<script>

export default {
  props: {
    selectedDepartmentIdFilter: Number,
    selectedStatusId: Number,
    selectedFromDate: String,
    selectedToDate: String,
    isFiltersApply: Boolean,
    isFiltersRemove: Boolean,
    newTicket: Object,
    closedTicketId: Number
  },
  data () {
    return {
      currentPage: 1,
      search: null,
      tickets: [],
      totalPage: 1,
      scrollSection: null,
      isTicketSelected: false,
      selectedTicket: null,
      department: null,
      selectedDepartmentId: null,
      toggleSelectionTicket: false,
      searchTimeout: null,
      intervalId: null
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData () {
      var app = this
      const existingIds = new Set(this.tickets.map(ticket => ticket.id))
      app.$axios.get(this.$endpoint + 'ticketing', {
        params: {
          page: this.currentPage,
          options: JSON.stringify({ page: this.currentPage, itemsPerPage: 8 }),
          department_id: this.resolveDepartmentId(),
          search: this.search == null ? null : this.search,
          status_id: this.selectedStatusId == null ? null : [this.selectedStatusId],
          fromDate: this.selectedFromDate != null ? this.selectedFromDate : null,
          toDate: this.selectedToDate != null ? this.selectedToDate : null,
          state: null
        }
      })
        .then(r => {
          const newTickets = r.data.data.filter(ticket => !existingIds.has(ticket.id))
          if (this.newTicket) {
            this.tickets.unshift(...newTickets)
          } else {
            this.tickets.push(...newTickets)
          }
          this.totalPage = r.data.last_page
        })
        .catch(e => {
          console.error('Error:', e)
        })
    },
    resolveDepartmentId () {
      if (this.selectedDepartmentId == null && this.selectedDepartmentIdFilter == null) {
        return null
      }
      if (this.selectedDepartmentId != null && this.selectedDepartmentIdFilter == null) {
        return [this.selectedDepartmentId]
      }
      if (this.selectedDepartmentIdFilter != null && this.selectedDepartmentId == null) {
        return [this.selectedDepartmentIdFilter]
      }
      if (this.selectedDepartmentId != null && this.selectedDepartmentIdFilter != null) {
        return null
      }
    },
    loadMore () {
      const scrollBottom = this.scrollSection.scrollHeight - this.scrollSection.scrollTop - this.scrollSection.clientHeight
      if (scrollBottom < 20 && this.currentPage < this.totalPage) {
        this.currentPage += 1
        this.fetchData()
      }
    },
    selectTicket (item, index) {
      this.isTicketSelected = true
      this.toggleSelectionTicket = !this.toggleSelectionTicket
      this.selectedTicket = index
      this.$emit('onSelectTicket', item)
    },
    createNewTicket () {
      this.isTicketSelected = false
      this.$emit('createNewTicket')
    },
    fetchDataWithoutDepartment () {
      this.selectedDepartmentId = null
      this.tickets = []
      this.currentPage = 1
      this.fetchData()
    },
    fetchDataWithoutSearch () {
      this.search = null
      this.tickets = []
      this.currentPage = 1
      this.fetchData()
    }
  },
  mounted () {
    this.$emit('ticketSelection', this.isTicketSelected)
    this.intervalId = setInterval(() => {
      this.fetchData()
    }, 20000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  },
  watch: {
    isFiltersApply (val) {
      this.tickets = []
      this.currentPage = 1
      this.fetchData()
    },
    isFiltersRemove (val) {
      this.tickets = []
      this.currentPage = 1
      this.fetchData()
    },
    isTicketSelected (val) {
      this.$emit('ticketSelection', this.isTicketSelected)
    },
    newTicket (val) {
      this.currentPage = 1
      this.fetchData()
    },
    closedTicketId (val) {
      /*  console.log(val) */
    },
    search (val) {
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        if (val) {
          this.tickets = []
          this.currentPage = 1
          this.fetchData()
        }
      }, 1000)
    },
    department (val) {
      if (val) {
        this.selectedDepartmentId = val.id
        this.tickets = []
        this.currentPage = 1
        this.fetchData()
      }
    },
    tickets (val) {
      this.$nextTick(() => {
        if (this.$refs.scrollSection) {
          this.scrollSection = this.$refs.scrollSection
          this.scrollSection.addEventListener('scroll', this.loadMore)
        }
      })
    },
    toggleSelectionTicket (val) {
      this.$emit('onToggleTicketSelection', this.toggleSelectionTicket)
    }
  }
}
</script>

<style scoped>
.wrapper-ticket-list .list {
    padding-right: 6px !important;
    height: 52.5vh;
    direction: ltr;
}
.wrapper-ticket-list .list .v-card {
    border: 1px solid #999999;
    border-radius: 4px !important;
    padding: 12px;
    height: 75px !important;
    margin-bottom: 13px !important;
    direction: rtl;
    cursor: pointer;
}
.wrapper-ticket-list .list .v-card.active {
    border-color: transparent !important;
    background-color: #D9EEFF;
}
.wrapper-ticket-list .list::-webkit-scrollbar {
  width: 4px;
}
.wrapper-ticket-list .list::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.wrapper-ticket-list .list::-webkit-scrollbar-thumb {
  background: #8888889f;
}
.wrapper-ticket-list .list::-webkit-scrollbar-thumb:hover {
  background: #555555cb;
}
.wrapper-ticket-list .wrapper-empty-ticket {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 95px;
}
.wrapper-ticket-list .wrapper-empty-ticket img {
    width: 130px;
}
</style>
